<template>
	<div class="c-container">
		<div class="c-contact-container">
			<div class="c-contact-coustom" :style="{'display': customDisplay}">
				<chat-custom @custom-call="customBack($event)" :showCount="true" :wxid="countWxid"></chat-custom>
			</div>
			<div class="c-contact-wrap" v-show="!searchOpen">
				<div class="c-contact-header">
					<div class="c-contact-menu">
						<p :class="{'c-menu-acitve':currentMenu == 'all'}" @click="changeClick('all')">全部</p>
						<p :class="{'c-menu-acitve':currentMenu == 'friends'}" @click="changeClick('friends')">个人</p>
						<p :class="{'c-menu-acitve':currentMenu == 'cluster'}" @click="changeClick('cluster')">群聊</p>
						<p :class="{'c-menu-acitve':currentMenu == 'no_read'}" @click="changeClick('no_read')">未读</p>
						<p :class="{'c-menu-acitve':currentMenu == 'no_reply'}" @click="changeClick('no_reply')">未回</p>
						<p :class="{'c-menu-acitve':currentMenu == 'collection'}" @click="changeClick('collection')">收藏</p>
						<p :class="{'c-menu-acitve':currentMenu == 'fans_transfer'}" @click="changeClick('fans_transfer')">转粉</p>
						<p :class="{'c-menu-acitve':currentMenu == 'more' || showMore}" @click="changeClick('more')" style="display: flex;align-items: center;justify-content: center;" v-if="moreMenu">
							<span>更多</span>
							<span class="c-contact-menu-more-down" :class="{'c-contact-menu-more-up': showMore}"></span>
						</p>
					</div>
				</div>
				<div class="c-contact-more" v-if="showMore">
					<p :class="{'c-contact-more-acitve':currentMenu == item.key+'_'+item.id}" @click="changeClick(item.key+'_'+item.id)" v-for="item in friendGroup">{{item.title}}</p>
					<p class="c-contact-menu-p" title="同步标签数据" @click="syncFriendGroupRel"><button class="c-contact-menu-btn"></button></p>
				</div>
				<div class="c-contact-box" :class="{'c-contact-box-top90' : showMore}">
					<chat-chat-all 
						:type="currentMenu" 
						:custom="custom" 
						:jumpChat="jumpChat"
						:recentlyModify="recentlyModify"
						:delFansId = "delFansId"
						@chat-click="chatClickCall($event)" 
						@custom-filter="customFilterCall($event)"
						@search-show-call="searchShowCall($event)"
						@recently-modify-call="recentlyModifyCall($event)"
						@compute-not-read="computeNotRead($event)">
					</chat-chat-all>
				</div>
			</div>
			<div class="c-contact-wrap" v-show="searchOpen">
				<chat-chat-search @search-show-call="searchShowCall($event)" @chat-click="chatClickCall($event)" @search-keyword="searchKeyword($event)"></chat-chat-search>
			</div>
		</div>
		<div class="c-chatting-box" v-if="currentChat.id != 0">
			<div class="c-chatting" :class="{'c-chatting-open' : !showTools}">
				<chat-chat-chatting :chatting='currentChat' :sKeyword="sKeyword" ref="chatChatChatting" @reshow-chatting="chatClickCall($event)" @transfer-fans="transferFans($event)"></chat-chat-chatting>
				<div class="c-fold" @click="contrTools">{{showTools ? '收起':'展开'}}</div>
			</div>
			<div class="c-tools" v-show="showTools">
				<chat-chat-tools @reply-click-call="replyClickCall($event)" :chatting="currentChat" @recently-modify-call="recentlyModifyCall($event)"></chat-chat-tools>
			</div>
		</div>
		<div class="c-chatting-box-empty" v-else>
			<chat-empty showText="请选择一个粉丝"></chat-empty>
		</div>
	</div>
</template>

<script>
	import ChatChatAll from './ChatChatAll.vue'
	import ChatCustom from '../../components/ChatCustom.vue'
	import ChatChatChatting from './ChatChatChatting.vue'
	import ChatChatTools from './ChatChatTools.vue'
	import ChatEmpty from '../../components/ChatEmpty.vue'
	import ChatChatSearch from './ChatChatSearch.vue'
	import {getLocalConfig} from '../../functions/Common.js'
	import {webGetAllFriendGroupRel} from  '../../network/web/friend_group_rel.js'
	import {deleteAll,save as saveFGR} from  '../../network/local/friend_group_rel.js'

	export default {
		name: 'ChatChat',
		data() {
			return {
				currentMenu: 'all',
				customDisplay: 'none',
				showTools: true,
				currentChat: {
					id: 0
				},
				custom: {
					open_id: ''
				},
				// 通过url传递的聊天对象信息，内容与currentChat属性一致
				jumpChat: {},
				searchOpen: false,
				recentlyModify:{},
				countWxid: {},
				sKeyword: '',
				delFansId: 0,
				moreMenu: false,
				showMore: false,
				friendGroup: []
			}
		},
		components: {
			ChatChatAll,
			ChatCustom,
			ChatChatChatting,
			ChatChatTools,
			ChatEmpty,
			ChatChatSearch
		},
		methods: {
			// 菜单点击切换
			changeClick(value) {
				// let closeList = ['all','friends','no_read','collection','fans_transfer'];
				let closeList = [];
				this.currentMenu = value
				if(value === 'more'){
					this.showMore = !this.showMore
				}else if(closeList.indexOf(value) !== -1){
					this.showMore = false
				}
			},

			// 客服切换回调
			customBack(value) {
				this.custom = value
			},

			// 客服过滤点击回调
			customFilterCall(val) {
				val ? this.customDisplay = 'block' : this.customDisplay = 'none'
			},

			//聊天列表点击回调
			chatClickCall(val) {
				if(val.chat_type == 1 && this.currentMenu === 'cluster'){
					this.currentMenu = 'all'
				}else if(val.chat_type == 2 && this.currentMenu === 'friends'){
					this.currentMenu = 'all'
				}
				this.currentChat = JSON.parse(JSON.stringify(val))
			},

			// 监听快捷语点击
			replyClickCall(val) {
				let data = {}
				if (val.type == 1) {
					data = {
						type: 'replyText',
						content: val.content
					}
				} else if (val.type == 3) {
					data = {
						type: 'replyImage',
						content: val.content
					}
				}
				this.$refs.chatChatChatting.chatToolsData = data
			},
			
			// 监听输入框打开/关闭回调
			searchShowCall(res){
				this.searchOpen = res
			},
			
			// 监听最近聊天收藏/置顶等的修改
			recentlyModifyCall(val){
				this.recentlyModify = val
			},
			
			// 聊天页面点击，新消息触发时回调
			computeNotRead(data){
				this.countWxid = {
					wxid: data
				}
				 this.$emit("compute-not-read")
			},
			
			// 搜索框，点击搜索历史记录回调
			searchKeyword(data){
				this.sKeyword = data
			},
			
			// 控制工具栏展开和隐藏
			contrTools(){
				this.showTools = !this.showTools
			},
			
			// 转移粉丝反射回调
			transferFans(data){
				console.log(data)
				this.currentChat = {
					id: 0
				}
				this.delFansId = parseInt(data.fans_id)
			},
			
			// 粉丝分组同步
			syncFriendGroupRel(){
				webGetAllFriendGroupRel(data=>{
					if(data.code == 1){
						deleteAll(data2=>{
							if(data2){
								let iList = data.data
								let successNum = 0
								for (let i = 0; i < iList.length; i++) {
									saveFGR(iList[i],res=>{
										if(res !== false){
											successNum++
										}
									})
								}
								CHAT_LAYER.msg('同步成功，切换标签查看！',{icon: 1})
							}else{
								CHAT_LAYER.msg('操作失败2',{icon: 1})
							}
						})
					}else{
						CHAT_LAYER.msg('操作失败',{icon: 2})
					}
				})
			},
			
			
			// 初始部分参数
			initConfig(){
				let friend_group = getLocalConfig('friend_group')
				if(friend_group === ''){
					return
				}
				friend_group = JSON.parse(friend_group)
				if(!(friend_group instanceof Array) ||  friend_group.length === 0){
					return
				}
				this.moreMenu = true
				this.friendGroup = friend_group
			}
		},
		beforeRouteEnter(to, from, next) {
			if (from.name == 'Login') {
				window.location.href = '/chat/chat'
			}
			next((vm)=>{
				if(from.path !== "/"){
					if(to.query.type !== undefined){
						vm.jumpChat = to.query
					}
				}
			})
		},
		
		// 组件创建的时候触发
		created(){
			this.initConfig()
		}
	}
</script>

<style>
	.c-container {
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: relative;
	}

	.c-container .c-contact-container {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 400px;
		background-color: #efefef;
		display: flex;
		justify-content: space-between;
		flex-direction: row;
		flex-wrap: nowrap;
	}

	.c-contact-container .c-contact-coustom {
		width: 80px;
		height: 100%;
		display: none;
	}

	.c-contact-container .c-contact-wrap {
		height: 100%;
		min-width: 320px;
		overflow: hidden;
		position: relative;
		flex-grow: 1;
	}

	.c-contact-wrap .c-contact-header {
		width: 100%;
		height: 50px;
		line-height: 50px;
		user-select: none;
	}

	.c-contact-header .c-contact-menu {
		width: 100%;
		height: 50px;
		overflow: hidden;
		display: flex;
		justify-content: space-around;
		flex-direction: row;
		flex-wrap: nowrap;
		align-items: center;
		align-content: center;
		font-weight: bold;
	}

	.c-contact-header .c-contact-menu p {
		width: 33.33%;
		height: 50px;
		text-align: center;
		font-size: 14px;
		border-bottom: 1px solid #cfcfcf;
		box-sizing: border-box;
		cursor: pointer;
	}

	.c-contact-menu .c-menu-acitve {
		border-bottom: #42B983 2px solid !important;
		color: #42B983;
	}

	.c-contact-wrap .c-contact-box {
		width: 100%;
		position: absolute;
		top: 50px;
		left: 0;
		bottom: 0;
	}
	.c-contact-wrap .c-contact-box-top90 {
		top: 90px !important;
	}

	.c-container .c-chatting-box,
	.c-container .c-chatting-box-empty {
		position: absolute;
		top: 0;
		left: 400px;
		bottom: 0;
		right: 0;
		overflow: hidden;
	}

	.c-chatting-box .c-chatting {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 300px;
		overflow: hidden;
	}
	
	.c-chatting-box .c-chatting-open{
		right: 0 !important;
	}

	.c-chatting-box .c-tools {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		width: 300px;
		overflow: hidden;
	}
	.c-chatting .c-fold{
		position: absolute;
		top: 50%;
		right: 0;
		width: 20px;
		text-align: center;
		transform: translateY(-50%);
		border: 1px solid #CCCCCC;
		border-right: none;
		line-height: 20px;
		padding: 5px 0;
		border-radius: 2px;
		background-color: #EEEEEE; 
		cursor: pointer;
		color: #888888;
	}
	.c-contact-more{
		height: 40px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 10px;
		flex-wrap: wrap;
		overflow: auto;
		border-bottom: 1px solid #d5d5d5;
	}
	.c-contact-more p{
		display: inline-block;
		margin: 0 5px;
		cursor: pointer;
		user-select: none;
		font-size: 12px;
	}
	.c-contact-more-acitve{
		color: #42B983;
		font-weight: bold;
	}
	.c-contact-menu-more-down{
		width: 16px;
		height: 16px;
		display: inline-block;
		background-position: center;
		background-image: url(../../assets/img/down.png);
		background-size: cover;
		background-repeat: no-repeat;
		margin-left: 2px;
	}
	.c-contact-menu-more-up{
		background-image: url(../../assets/img/up.png) !important;
	}
	.c-contact-menu-p{
		display: flex !important;
		align-items: center;
	}
	.c-contact-menu-btn{
		cursor: pointer;
		background-image: url(../../assets/img/refresh.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		width: 20px;
		height: 20px;
	}
</style>
